module.exports = __webpack_public_path__ + "img/sf_alctraz.1955828f.png";